import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-dark-bg border-b border-gray-800 sticky top-0 z-50" itemScope itemType="http://schema.org/WPHeader">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" data-discover="true" itemProp="url" className="flex items-center space-x-2 group" itemScope itemType="http://schema.org/Organization">
            <img 
              src="/images/favicon.webp" 
              alt="Hexabet Connect" 
              itemProp="logo"
              className="w-8 h-8 group-hover:scale-110 transition-transform duration-300"
            />
            <span className="text-2xl font-bold text-white" itemProp="name">Hexabet Connect</span>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" data-discover="true" className="text-gray-300 hover:text-toxic-green transition-colors">
              Accueil
            </Link>
            <Link to="/guides" data-discover="true" className="text-gray-300 hover:text-toxic-green transition-colors">
              Guides
            </Link>
            <Link to="/reviews" data-discover="true" className="text-gray-300 hover:text-toxic-green transition-colors">
              Avis
            </Link>
            <Link to="/news" data-discover="true" className="text-gray-300 hover:text-toxic-green transition-colors">
              Actualités
            </Link>
          </nav>

          <button
            className="md:hidden text-gray-300 hover:text-toxic-green"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-4">
            <Link
              to="/"
              data-discover="true"
              className="block text-gray-300 hover:text-toxic-green transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Accueil
            </Link>
            <Link
              to="/guides"
              data-discover="true"
              className="block text-gray-300 hover:text-toxic-green transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Guides
            </Link>
            <Link
              to="/reviews"
              data-discover="true"
              className="block text-gray-300 hover:text-toxic-green transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Avis
            </Link>
            <Link
              to="/news"
              data-discover="true"
              className="block text-gray-300 hover:text-toxic-green transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Actualités
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;

